import {
  GENERATE_REPORT_SUCCESS,
  GENERATE_REPORT_FAIL,
  OPEN_AI_REFINE_TEXT_SUCCESS,
  OPEN_AI_REFINE_TEXT_FAIL,
  STORE_REFINED_TEXT_SUCCESS,
  STORE_REFINED_TEXT_FAIL,
  GET_REFIENED_PROGRESS_NOTES_LIST,
  GET_REFIENED_PROGRESS_NOTES_LIST_SUCCESS,
  GET_REFIENED_PROGRESS_NOTES_LIST_FAIL,
  UPDATE_REPORT_SUCCESS,
  UPDATE_REPORT_FAIL,
  DELETE_REPORT_SUCCESS,
  DELETE_REPORT_FAIL,
  GET_REPORT_LOGS_SUCCESS,
  GET_REPORT_LOGS_FAIL,
  APPROVE_REPORT_SUCCESS,
  APPROVE_REPORT_FAIL,
  REPORT_ATTACHMENT_LIST_SUCCESS,
  REPORT_ATTACHMENT_LIST_FAIL,
  SAVE_REPORT_ATTACHMENT_SUCCESS,
  SAVE_REPORT_ATTACHMENT_FAIL,
  REPORT_ATTACHMENT_LIST,
  DELETE_REPORT_ATTACHMENT_SUCCESS,
  DELETE_REPORT_ATTACHMENT_FAIL,
  GET_TASK_REPORT_DETAIL_SUCCESS,
  GET_TASK_REPORT_DETAIL_FAIL,
  SET_REPORT_PAGINATION,
} from "./actionTypes";

const INIT_STATE = {
  list: [],
  res: [],
  error: [],
  openAiRes: [],
  notesList: [],
  logs: [],
  loading: false,
  attachmentList: [],

  pagination: {
    pageIndex: 0,
    pageSize: 20,
    pageCount: 0,
    totalRecords: 0,
  },
};

const ChatGPT = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_REPORT_PAGINATION:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...(action.payload?.field ? { [action.payload.field]: action.payload.value } : action.payload),
        },
      };

    case APPROVE_REPORT_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case APPROVE_REPORT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_TASK_REPORT_DETAIL_SUCCESS:
      return {
        ...state,
        list: action.payload,
      };
    case GET_TASK_REPORT_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case DELETE_REPORT_ATTACHMENT_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case DELETE_REPORT_ATTACHMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case SAVE_REPORT_ATTACHMENT_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case SAVE_REPORT_ATTACHMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case REPORT_ATTACHMENT_LIST:
      return {
        ...state,
        loading: true,
      };
    case REPORT_ATTACHMENT_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        attachmentList: action.payload,
      };
    case REPORT_ATTACHMENT_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case UPDATE_REPORT_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case UPDATE_REPORT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_REPORT_LOGS_SUCCESS:
      return {
        ...state,
        logs: action.payload,
      };
    case GET_REPORT_LOGS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case DELETE_REPORT_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case DELETE_REPORT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case STORE_REFINED_TEXT_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case STORE_REFINED_TEXT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_REFIENED_PROGRESS_NOTES_LIST:
      return {
        ...state,
        loading: true,
      };
    case GET_REFIENED_PROGRESS_NOTES_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.payload,
        pagination: {
          pageIndex: action.payload.pagination.page - 1,
          pageSize: action.payload.pagination.limit,
          pageCount: action.payload.pagination.total_pages,
          totalRecords: action.payload.pagination.total,
        },
        // meta: action.payload.meta,
      };
    case GET_REFIENED_PROGRESS_NOTES_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case GENERATE_REPORT_SUCCESS:
      return {
        ...state,
        notesList: action.payload,
      };
    case GENERATE_REPORT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case OPEN_AI_REFINE_TEXT_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case OPEN_AI_REFINE_TEXT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default ChatGPT;
